module.exports = __webpack_public_path__ + "static/img/avatar_1.072a15f.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_1.png
// module id = 1589
// module chunks = 61